<template>
    <div class="vrm-filter_options__checks">
        <label v-for="option in options" :key="option.id" class="vrm-filter_options__check">
            <span>
                {{
                    option.i18n
                        ? $t(option.i18n, {
                              i18nFallback: option.label,
                          })
                        : option.label
                }}
            </span>
            <input :id="option.id" v-model="option.value" type="checkbox" @change="submit" />
            <div class="sg-alternative-display">
                <div class="sg-icon-check" />
            </div>
        </label>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('installationoverview')
@AngularLocaleBundle('tags')
@AngularLocaleBundle('dashboard')
@AngularLocaleBundle('core')
export default class VrmInstallationOverviewFilterCheck extends Vue {
    @Prop({ type: Array, default: [] })
    options;

    submit() {
        this.$emit('submit');
    }
}
</script>
